import { Component, OnInit } from '@angular/core';
import { Config } from '../../_store';

@Component({
  selector: 'product-item-header-multiple',
  templateUrl: './product-item-header-multiple.component.html',
})
export class ProductItemHeaderMultipleComponent implements OnInit {
  productHeader = Config.productItemHeading.multiple;
  constructor() { }
  ngOnInit() {}
}
